import useApiMutation from 'shared/hooks/use-api-mutation';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

export interface QueryDeleteButtonProps {
  url: string;
  queryKey: any;
  method?: string;
  type?: 'update' | 'set';
}

const useButtonState = ({
  url,
  queryKey,
  method = 'DELETE',
  type = 'set',
}: QueryDeleteButtonProps) => {
  const {setData, remove} = useQueryHelpers();

  const onSuccess = (data: any) => {
    if (type === 'update') return remove(queryKey, data);
    if (type === 'set') return setData(queryKey, data);
  };

  const {mutate, isLoading} = useApiMutation({
    method,
    url,
    errorTitle: 'Erro ao remover registro',
    successTitle: 'Remover registro',
    successMessage: 'Registro removido com sucesso',
    onSuccess,
  });

  const handleRequest = () => {
    mutate(undefined);
  };

  return {
    handleRequest,
    isLoading,
  };
};

export default useButtonState;
